import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "../typography"; 
import FormControl from "@material-ui/core/FormControl";
import Hidden from "@material-ui/core/Hidden";
//LOADING MODAL
import Loading from '../loading'; 
import RoomIcon from "@material-ui/icons/Room";
import ApartmentIcon from "@material-ui/icons/Apartment";
import MailIcon from "@material-ui/icons/Mail";
import PhoneIcon from "@material-ui/icons/Phone";
//FIREBASE CLIENT
import Firebase from "../../firebase/clientApp";
//Captcha
import ReCAPTCHA from "react-google-recaptcha"; 
//DateTime
import moment from "moment";
import "moment/locale/es";
//STYLES
import useStyles from "./style.js";


const initialState = {
  userName: "",
  userNameState: false,
  userNameError: "",
  userMail: "",
  userMailState: false,
  userMailError: "",
  userPhone: "",
  userPhoneState: false,
  userPhoneError: "",
  usermessage: "",
  usermessageState: false,
  usermessageError: "",
  recaptcha: "",
  recaptchaIsValid: false,
  recaptchaState: false,
  recaptchaError: "",
  statemodal: false,
  titleModal: 'Enviando Mensaje...', 
  contentmodal: "Procesando Solicitud, espere un momento",
  isLoading: true,
  isSuccesfull: false,
  isUnsuccessful: false,
  isBadRequest: false,
}

export default function sdcdscsdc(){

  const classes = useStyles();
  const [credentials, setCredentials] = useState(initialState)
 
  const toggleModal = () => { 
    setCredentials(prevState => ({
        ...prevState, 
        statemodal: !prevstate.statemodal 
    })); 
  }

  const onChange = (data) => {
    if (data.length > 0) {  
      setCredentials(prevState => ({
        ...prevState, 
        recaptcha: data,
        recaptchaIsValid: true
    })); 
    }
  }

  const handleChange = (e) => {   
    const { name, value } = e.target;
    setCredentials(prevState => ({...prevState, [name]: value})); 
  }

  const clearData = () => {
    toggleModal();
    setState(() => ({
    userName: "",
    //userName: "axasxasx asas",
    userNameState: false,
    userNameError: "",

    userMail: "",
    //userMail: "sdcsdcsd@sdcsdcsd.sdc",
    userMailState: false,
    userMailError: "",

    userPhone: "",
    //userPhone: "54545554545",
    userPhoneState: false,
    userPhoneError: "",

    usermessage: "",
    //usermessage: "Lorem ipsum dolor them",
    usermessageState: false,
    usermessageError: "",

    recaptcha: "",
    recaptchaIsValid: false,
    recaptchaState: false,
    recaptchaError: "",
 
    contentmodal: "",
    isLoading: false,
    isSuccesfull: false,
    isUnsuccessful: false,
    isBadRequest: false,
    }));
  }

  const sentForm = async () => {
    try {
      let status = await validateInput();
      if (!status) {
        toggleModal(); 
        await moment.locale("es");
        let currentDate = await moment(Date.now()).format("LLLL");
        //console.log(currentDate)

        let data = await {
          name: credentials.userName,
          email: credentials.userMail,
          phone: credentials.userPhone,
          message: credentials.usermessage,
          date: currentDate,
          captcha: credentials.recaptcha,
        };
        //console.log(data)

        let sendMail = await Firebase.functions().httpsCallable("sendEmailMessage");   
        let statusMail = await sendMail(data);
        //console.log(statusMail);

        if (statusMail.data.successStatus) {
          setState(() => ({
            titleModal: 'Mensaje Enviado', 
            contentmodal:  "Su mensaje ha sido enviado, nos pondremos en contacto lo antes posible.",
            isBadRequest: false,
            isUnsuccessful: false,
            isLoading: false,
            isSuccesfull: true,
            statemodal: true,
          })); 
        } else {
          setState(() => ({
            titleModal: 'Error', 
            contentmodal: "Error, su mensaje no ha podido ser enviado, por favor intentelo en otro momento.",
            isBadRequest: false,
            isLoading: false,
            isSuccesfull: false,
            isUnsuccessful: true,
            statemodal: true,
          })); 
        }
      }
    } catch (error) {
      console.log("New Error: ", error);
      setState(() => ({
        titleModal: 'Error', 
        contentmodal: "Error, no se puede enviar mensajes, por favor contacte al administrador.",
        isLoading: false,
        isSuccesfull: false,
        isUnsuccessful: false,
        isBadRequest: true,
        statemodal: true,
      })); 
    }
  }

  const validateInput = () => {
    let stateErrors = false;
    let re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let numbers = /^[0-9 ()+-]+$/;
    let letterSpace = /^([^0-9]*)$/;

    //Nombre completo
    if (letterSpace.test(credentials.userName) &&credentials.userName.length >= 2) {
      setState({
        userNameState: false,
        userNameError: "",
      });
    } else {
      if (credentials.userName.length < 2) {
        setState({
          userNameState: true,
          userNameError: "Ingrese un Nombre",
        });
        stateErrors = true;
      } else {
        setState({
          userNameState: true,
          userNameError: "No utilizar números",
        });
        stateErrors = true;
      }
    }
    //Celular
    if (numbers.test(credentials.userPhone) && credentials.userPhone.length >= 10) {
      setState({
        userPhoneState: false,
        userPhoneError: "",
      });
    } else {
      setState({
        userPhoneState: true,
        userPhoneError: "Ingrese celular válido",
      });
      stateErrors = true;
    }
    //Correo
    if (re.test(credentials.userMail)) {
      setState({
        userMailState: false,
        userMailError: "",
      });
    } else {
      setState({
        userMailState: true,
        userMailError: "Ingrese un correo válido",
      });
      stateErrors = true;
    }
    //Mensaje
    if (credentials.usermessage.length >= 4) {
      setState({
        usermessageState: false,
        usermessageError: "",
      });
    } else {
      setState({
        usermessageState: true,
        usermessageError: "Ingrese un mensaje",
      });
      stateErrors = true;
    }
    //Recapcha
    if (credentials.recaptchaIsValid === true) {
      setState({
        recaptchaState: false,
        recaptchaError: "",
      });
    } else {
      setState({
        recaptchaState: true,
        recaptchaError: "Valide la casilla",
      });
      stateErrors = true;
    }
    //console.log(state);
    return stateErrors;
  }



  return (
    <Grid
      container
      className={classes.root}
      direction="row"
      justify="space-around"
      alignItems="stretch"
    >
      <Grid item xs={11} md={6} className={classes.content}>
        <Paper elevation={3} className={classes.paperContent}>
          <Grid
            container
            className={classes.papercontainer}
            direction="column"
            justify="space-between"
            alignItems="stretch"
          >
            <Grid className={classes.paperTitte}>
              <Typography
                variant="h4"
                align="left"
                className={classes.cardtittle}
              >Contacto</Typography>
            </Grid>

            <Grid container justify="center">
              <Grid item xs={10} className={classes.paperForm}>
                <FormControl fullWidth>
                  <TextField
                    id="userName"
                    error={credentials.userNameState}
                    style={{ color: "blue" }}
                    label="Nombre"
                    name="userName"
                    value={credentials.name}
                    margin="normal"
                    helperText={credentials.userNameError}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={10} className={classes.paperForm}>
                <FormControl fullWidth>
                  <TextField
                    id="userMail"
                    error={credentials.userMailState}
                    style={{ color: "blue" }}
                    label="Correo"
                    name="userMail"
                    value={credentials.name}
                    margin="normal"
                    helperText={credentials.userMailError}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={10} className={classes.paperForm}>
                <FormControl fullWidth>
                  <TextField
                    id="userPhone"
                    error={credentials.userPhoneState}
                    style={{ color: "blue" }}
                    label="Teléfono"
                    name="userPhone"
                    value={credentials.name}
                    margin="normal"
                    helperText={credentials.userPhoneError}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={10} className={classes.paperFormMessage}>
                <FormControl fullWidth>
                  <TextField
                    id="usermessage"
                    error={credentials.usermessageState}
                    style={{ color: "blue" }}
                    label="Mensaje"
                    name="usermessage"
                    multiline
                    rows={5}
                    variant="outlined"
                    value={credentials.name}
                    margin="normal"
                    helperText={credentials.usermessageError}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>

              <Grid
                container
                item
                xs={10}
                direction="row"
                justify="space-between"
                alignItems="center"
                className={classes.paperAction}
              >
                <Grid item>
                  <Hidden smUp>
                    <ReCAPTCHA
                      size="compact" 
                      sitekey={process.env.CAPTCHA_KEY_GOOGLE}
                      //sitekey={keys.captchaKey}
                      onChange={onChange}
                    />
                  </Hidden>
                  <Hidden xsDown>
                    <ReCAPTCHA 
                      //sitekey={keys.captchaKey}
                      sitekey={process.env.CAPTCHA_KEY_GOOGLE}
                      onChange={onChange}
                    />
                  </Hidden>
                  <FormHelperText error={credentials.recaptchaState}>
                    {credentials.recaptchaError}
                  </FormHelperText>
                </Grid>
                <Button
                  className={classes.button}
                  size="large"
                  onClick={sentForm}
                >Enviar</Button>

              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={11} md={5} className={classes.content}>
        <Grid container direction="row" justify="center" alignItems="center" className={classes.paperContent} >
          <Grid item xs={12}>
            <Typography variant="h4" align="center" className={classes.textListtittle} >
              Contacto Directo
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.gridList}>
            <Typography variant="h5" align="left" className={classes.textList} >
              <RoomIcon className={classes.iconList}/>
              Bogotá, Colombia
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.gridList}>
            <Typography variant="h5" align="left" className={classes.textList} >
              <ApartmentIcon className={classes.iconList} />
              Calle 51a No. 6 - 30 Ofic. 603
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.gridList}>
            <Typography variant="h5" align="left" className={classes.textList} >
              <MailIcon className={classes.iconList} />
              direccion@cidu.com.co
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.gridList}>
            <Typography variant="h5" align="left" className={classes.textList}>
              <PhoneIcon className={classes.iconList} />
              301 460 69 80
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Loadin Modal Loading Modal */}
      <Loading  
        show={credentials.statemodal} 
        title={credentials.titleModal}
        handleClose={toggleModal}
        isLoading={credentials.isLoading}
        isSuccesfull={credentials.isSuccesfull} 
        isUnsuccessful={credentials.isUnsuccessful}
        isBadRequest={credentials.isBadRequest}
        messageModal={credentials.contentmodal} 
        actionBtn={clearData} /> 

    </Grid>
  );
} 